import Redux from 'redux'
import * as Modal from '../../../components/modal'
import * as Request from '../../../request'
import * as Constants from './constants'
import * as Types from './types'

export const showModal = () => ({type: Modal.toggleModalConstant(Constants.ADD_MEMBER)})
export const updateModalField: Modal.Update = Modal.updateModal(Constants.ADD_MEMBER)
export interface UpdateAttributeAction extends Redux.Action { index: number, field: Modal.ModalField }
export type UpdateAttributeFn = (index: number, field: Modal.ModalField) => UpdateAttributeAction
export const updateAttribute: UpdateAttributeFn = (index: number, field: Modal.ModalField) =>
  ({type: Constants.EDIT_MEMBER_ATTRIBUTE, index, field})

export interface EditAttributeAction extends Redux.Action { index: number }
export type EditAttributeFn = (index: number) => EditAttributeAction
export const editAttribute: EditAttributeFn = (index: number) =>
  ({type: Constants.CLICK_MEMBER_ATTRIBUTE, index})

export type AddAttributeAction = Redux.Action
export type AddAttributeFn = () => AddAttributeAction
export const addAttribute: AddAttributeFn = () =>
  ({type: Constants.ADD_MEMBER_ATTRIBUTE})

export const create: Modal.Submit<Types.ModalData> = (community: string, data: Types.ModalData) =>
  Request.requestActionCreator(Constants.ADD_MEMBER)({
    method: 'POST',
    payload: data,
    url: `${Constants.SERVER_RESOURCE}/${community}`,
  })



// WEBPACK FOOTER //
// ./src/pages/members/add-modal/actions.ts